import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useIntl, FormattedMessage } from "react-intl";
import { useSnackbar } from "notistack";
// Redux
import { useDispatch } from "react-redux";
import { setCurrentStakeholder } from "../../../redux/features/stakeholder/stakeholderSlice";
import { fetchToken } from "../../../redux/features/login/loginActions";
import { fetchNotifications } from "../../../redux/features/notifications/notificationActions";

// Services
import * as industryCategory from "../../../services/IndustryCategory";
import * as loginService from "../../../services/Login";
import * as stakeholderService from "../../../services/Stakeholder";

// Material-UI
import { Grid, makeStyles } from "@material-ui/core";
import {
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// Components
import { LayoutSplashScreen } from "../../../_metronic/layout";
import StaticCriteriaQuestions from "./pages/StaticRegistrations";
import { InstitutionVoens } from "./constants";
// Pages
import SelectIndustryCategory from "./pages/SelectIndustryCategory";

// Utilities
import {
  STEPS,
  FILE_SIZE,
  SUPPORTED_PHOTO_TYPES,
  objects,
} from "../../utils/constants";
import {
  checkObjects,
  getObjects,
  prepareStaticAppForm,
} from "../../utils/utilityFunctions";
import {
  InstitutionRegistrationModel,
  lastRegistrationModel,
} from "../../utils/StaticRegistration/model";
import {
  setIndustryCategory,
  setPerson,
  setPersonDetails,
} from "../../../redux/features/login/loginSlice";
import InstitutionRegistryQuestions from "./pages/InstitutionRegistryQuestions";
import webConfig from "web.config.map";

const Registration = ({
  history,
  personDetails,
  voenIsRequired,
  selectedCertificate,
  handleBackButton,
  voens,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const classes = useStyle();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [registrationStep, setRegistrationStep] = useState(null);
  const [industryCategories, setIndustryCategories] = useState([]);
  const [selectedIndustryCategory, setSelectedIndustryCategory] = useState("");
  const [selectedObjectName, setSelectedObjectName] = useState("");
  const [registredStakeholders, setRegistredStakeholders] = useState([]);
  const [newObjectName, setnewObjectName] = useState("");
  const [newObjectCode, setnewObjectCode] = useState("");
  // const [reviewPageLoading, setReviewPageLoading] = useState(false);
  const [dialogCount, setDialogCount] = useState(0);
  const [registeredObjects, setRegisteredObjects] = useState();
  // Static Registration+ Disabled Button
  const [disabled, setDisabled] = useState(true);
  // useState for Modal
  const [open, setOpen] = useState(false);
  const [responsibilityModal, setResponsibilityModal] = useState(false);

  const handleClickOpen = () => {
    setDialogCount(dialogCount + 1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validateAction = () => {
    if (
      selectedIndustryCategory?.name?.az !== "Bələdçilər" &&
      !checkIsInstitution(personDetails?.structureData?.voen)
    ) {
      return Yup.object().shape({
        city: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .nullable(),
        legalAddress: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" })),

        groupOfCompanies: Yup.string()
          .trim()
          .nullable(),

        objectName: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        objectAddress: Yup.object()
          .shape({
            label: Yup.string().required(
              intl.formatMessage({ id: "error.required" })
            ),
            lat: Yup.number().required(
              intl.formatMessage({ id: "error.required" })
            ),
            lng: Yup.number().required(
              intl.formatMessage({ id: "error.required" })
            ),
          })
          .required(intl.formatMessage({ id: "error.required" })),
        objectCode: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        personInChargeName: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(30, intl.formatMessage({ id: "error.too_long" })),
        personInChargePosition: Yup.object().shape({
          az: Yup.string()
            .trim()
            .required(intl.formatMessage({ id: "error.required" }))
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
          en: Yup.string()
            .trim()
            .optional()
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
          ru: Yup.string()
            .trim()
            .optional()
            .min(3, intl.formatMessage({ id: "error.too_short" }))
            .max(50, intl.formatMessage({ id: "error.too_long" })),
        }),
        personInChargePhone: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),

        managerName: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(30, intl.formatMessage({ id: "error.too_long" })),
        website: Yup.string()
          .trim()
          .optional()
          .url("error.url")
          .max(50, intl.formatMessage({ id: "error.too_long" })),
        objectRegisterationDate: Yup.date()
          .min(new Date("1970-01-01").toUTCString())
          .max(new Date().toUTCString())
          .required(intl.formatMessage({ id: "error.required" }))
          .nullable(),
        brandName: Yup.string()
          .trim()
          .optional()
          .min(2, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" }))
          .nullable(),
        email: Yup.string(intl.formatMessage({ id: "error.required" }))
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" }))
          .nullable(),
        phone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" }))
          .nullable(),
        photo: Yup.array()
          .test(
            "fileSize",
            <FormattedMessage id="error.filesize">
              {(txt) => `${txt} ${Math.floor(FILE_SIZE / 1000000)} Mb`}
            </FormattedMessage>,
            (files) => {
              if (!files?.length) return true;
              if (files[0].url) return false;
              let valid = true;
              for (const file of files) {
                if (file.size > FILE_SIZE) {
                  valid = false;
                }
              }
              return !files || valid;
            }
          )
          .test(
            "fileType",
            <FormattedMessage id="error.phototype" />,
            (files) => {
              if (!files?.length) return true;
              if (files[0]?.url) return false;
              let valid = true;
              for (const file of files) {
                if (!SUPPORTED_PHOTO_TYPES.includes(file.type)) {
                  valid = false;
                }
              }
              return !files || valid;
            }
          )
          .test({
            message: <FormattedMessage id="error.photo_not_selected" />,
            test: (arr) => {
              if (!arr?.length) return false;
              return arr.length > 0;
            },
          }),
      });
    } else if (
      selectedIndustryCategory?.name?.az === "Yerləşmə vasitələri".toLowerCase()
    ) {
      return Yup.object().shape({
        bedCount: Yup.string().required(),
        roomCount: Yup.string().required(),
      });
    } else if (checkIsInstitution(personDetails?.structureData?.voen)) {
      return Yup.object().shape({
        nationality: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),
        personInChargeEmail: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" })),
        personInChargePhone: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),
      });
    } else {
      return Yup.object().shape({
        city: Yup.string()
          .required(intl.formatMessage({ id: "error.required" }))
          .nullable(),
        nationality: Yup.string()
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .min(3, intl.formatMessage({ id: "error.too_short" }))
          .max(512, intl.formatMessage({ id: "error.too_long" })),

        email: Yup.string(intl.formatMessage({ id: "error.required" }))
          .trim()
          .required(intl.formatMessage({ id: "error.required" }))
          .email(intl.formatMessage({ id: "error.email" }))
          .min(8, intl.formatMessage({ id: "error.too_short" }))
          .max(128, intl.formatMessage({ id: "error.too_long" })),
        phone: Yup.string(intl.formatMessage({ id: "error.required" }))
          .required(intl.formatMessage({ id: "error.required" }))
          .min(12, intl.formatMessage({ id: "error.too_short" })),
        photo: Yup.array()
          .test(
            "fileSize",
            <FormattedMessage id="error.filesize">
              {(txt) => `${txt} ${Math.floor(FILE_SIZE / 1000000)} Mb`}
            </FormattedMessage>,
            (files) => {
              if (!files?.length) return true;
              if (files[0].url) return false;
              let valid = true;
              for (const file of files) {
                if (file.size > FILE_SIZE) {
                  valid = false;
                }
              }
              return !files || valid;
            }
          )
          .test(
            "fileType",
            <FormattedMessage id="error.phototype" />,
            (files) => {
              if (!files?.length) return true;
              if (files[0]?.url) return false;
              let valid = true;
              for (const file of files) {
                if (!SUPPORTED_PHOTO_TYPES.includes(file.type)) {
                  valid = false;
                }
              }
              return !files || valid;
            }
          )
          .test({
            message: <FormattedMessage id="error.photo_not_selected" />,
            test: (arr) => {
              if (!arr?.length) return false;
              return arr.length > 0;
            },
          }),
      });
    }
  };

  // const checkIsInstitution = (structureName) => {
  //   return structureNameList.some((i) => i?.structureName === structureName);
  // };

  const checkIsInstitution = (voen) => {
    const voenList = Object.values(InstitutionVoens).filter((item) => item);
    return Boolean(voenList.includes(voen));
  };

  const formik = useFormik({
    initialValues: checkIsInstitution(personDetails?.structureData?.voen)
      ? InstitutionRegistrationModel
      : lastRegistrationModel,
    enableReinitialize: true,
    validationSchema: validateAction(),
    onSubmit: (values) => {
      console.log("[REGISTRATION DEBUG] formik.onSubmit: Starting submission", {
        hasVoen: !!formik?.values?.voen,
        brandName: values.brandName,
        dialogCount,
        isInstitution: checkIsInstitution(personDetails?.structureData?.voen),
        selectedIndustryCategory: selectedIndustryCategory?.name,
      });
      if (formik?.values?.voen) {
        if (values.brandName === undefined && dialogCount === 0) {
          console.log(
            "[REGISTRATION DEBUG] formik.onSubmit: Opening brand name dialog"
          );
          handleClickOpen();
          return;
        }
      }

      const isInstitution = checkIsInstitution(
        personDetails?.structureData?.voen
      );

      if (isInstitution) {
        console.log(
          "[REGISTRATION DEBUG] formik.onSubmit: Institution detected, showing responsibility modal"
        );
        toggleResponsibilityModal();
      } else {
        console.log("[REGISTRATION DEBUG] formik.onSubmit: Regular submission");
        submitGradeApplication();
      }
    },
  });

  useEffect(() => {
    dispatch(setPerson(personDetails));
    dispatch(setPersonDetails(personDetails));

    checkIsInstitution(personDetails?.structureData?.voen)
      ? handleIndustrySubmit()
      : setRegistrationStep(STEPS.INDUSTRY_CHOICE);
  }, [personDetails]);

  useEffect(() => {
    let isMounted = true;
    (async function getASANCerts() {
      try {
        setLoading(true);
        const industryCategories = await industryCategory.getIndustryCategoriesByVoen(
          voenIsRequired
        );
        if (isMounted) {
          setIndustryCategories(industryCategories.data);
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
        enqueueSnackbar(
          intl.formatMessage({
            id: err?.response?.data.message || err.message,
          }),
          { variant: "error" }
        );
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (selectedCertificate?.voen) {
      formik.values.name = selectedCertificate?.structureName;
      formik.values.voen = selectedCertificate?.voen;
      formik.values.isVoen = true;
      (async function checkRegistrationObjects() {
        if (objects.length !== 0) {
          if (objects.length > 1) {
            //  let response = await checkObjects(selectedCertificate?.voen);
            let response = await getObjects(selectedCertificate?.voen);
            if (isMounted) {
              setRegistredStakeholders(response?.data?.stakeholders);
              setRegisteredObjects(response?.data?.stakeholders);
            }
          }
        }
      })();
    } else if (checkIsInstitution(personDetails?.structureData?.voen)) {
      formik.values.pin = personDetails?.pin;
      formik.values.isVoen = true;
    } else {
      formik.values.name = personDetails?.name
        ? `${personDetails?.name} ${personDetails?.surname} ${personDetails?.patronymic}`
        : "";
      formik.values.pin = personDetails?.pin;
      formik.values.isVoen = false;
      formik.values.isGuide = true;
    }

    return () => {
      isMounted = false;
    };
  }, [selectedCertificate, personDetails]);

  useEffect(() => {
    if (
      Object.entries(formik.touched).length !== 0 &&
      Object.entries(formik.errors).length === 0
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [formik, handleClickOpen]);

  useEffect(() => {
    if (dialogCount > 0 || formik.values.brandName === "") {
      formik.values.brandName = formik.values.objectName;
    }
  }, [dialogCount]);

  const toggleResponsibilityModal = () =>
    setResponsibilityModal((prev) => !prev);

  const handleIndustrySubmit = async () => {
    console.log("[REGISTRATION DEBUG] handleIndustrySubmit: Starting...", {
      selectedIndustryCategory: selectedIndustryCategory?.name,
      selectedObjectName: selectedObjectName,
      hasSelectedCertificate: !!selectedCertificate,
      certificateVoen: selectedCertificate?.voen,
      personVoen: personDetails?.structureData?.voen,
    });
    try {
      setLoading(true);
      dispatch(setIndustryCategory(selectedIndustryCategory));

      if (
        selectedCertificate?.voen &&
        (selectedIndustryCategory?.name?.az !== "Bələdçilər") &
          !checkIsInstitution(personDetails?.structureData?.voen)
      ) {
        console.log(
          "[REGISTRATION DEBUG] handleIndustrySubmit: Non-guide registration path"
        );
        if (selectedObjectName?._id) {
          console.log(
            "[REGISTRATION DEBUG] handleIndustrySubmit: Existing object selected",
            {
              objectId: selectedObjectName?._id,
              objectName: selectedObjectName.name,
              objectCode: selectedObjectName.objectCode,
            }
          );
          formik.values.objectCode = selectedObjectName.objectCode;
          formik.values.objectName = selectedObjectName.name;
          let resp = await dispatch(
            fetchToken({ id: selectedObjectName?._id })
          );
          console.log(
            "[REGISTRATION DEBUG] handleIndustrySubmit: Token fetch response",
            {
              hasData: !!resp?.data,
              isActive: resp?.data?.active,
            }
          );

          await dispatch(fetchNotifications(selectedObjectName?._id));
          if (resp?.data && resp?.data?.active) {
            // history.replace("/stakeholder/cabinet/home");
            window.location.href = "/stakeholder/cabinet/home";
          } else if (resp?.data && !resp?.data?.active) {
            history.replace("/stakeholder/new");
          } else {
            enqueueSnackbar(intl.formatMessage({ id: resp.message }), {
              variant: "error",
            });
          }
        } else {
          console.log(
            "[REGISTRATION DEBUG] handleIndustrySubmit: New object registration",
            {
              industryCategoryId: selectedIndustryCategory?._id,
              newObjectName: newObjectName || selectedObjectName,
              newObjectCode,
            }
          );
          formik.values.industryCategory = selectedIndustryCategory?._id;
          formik.values.objectName = newObjectName || selectedObjectName;
          formik.values.objectCode = newObjectCode;
          setRegistrationStep(STEPS.STATIC_CRITERIA_QUESTIONS);
        }
      } else if (checkIsInstitution(personDetails?.structureData?.voen)) {
        console.log(
          "[REGISTRATION DEBUG] handleIndustrySubmit: Institution registration path",
          {
            voen: selectedCertificate.voen,
            pin: personDetails.pin,
          }
        );
        let body = {
          pin: personDetails.pin,
          voen: selectedCertificate.voen,
          // voen: personDetails.structureData.voen,
        };

        console.log(
          "[REGISTRATION DEBUG] handleIndustrySubmit: Fetching stakeholder by PIN and VOEN..."
        );
        const resp = await stakeholderService.getStakeholderByPinAndVoen(body);
        console.log(
          "[REGISTRATION DEBUG] handleIndustrySubmit: Stakeholder fetch response",
          {
            hasData: !!resp?.data,
            dataLength: resp?.data?.length,
          }
        );
        if (resp?.data.at(-1)) {
          let response = await dispatch(
            fetchToken({ id: resp?.data.at(-1)?._id })
          );
          await dispatch(fetchNotifications(resp?.data.at(-1)?._id));
          if (response?.data && response?.data?.stakeholder?.active) {
            // history.replace("/stakeholder/cabinet/home");
            window.location.href = "/stakeholder/cabinet/home";
          } else if (response?.data && !response?.data?.stakeholder?.active) {
            history.replace("/stakeholder/new");
          } else {
            enqueueSnackbar(intl.formatMessage({ id: response.message }), {
              variant: "error",
            });
          }
        } else {
          setRegistrationStep(STEPS.INSTITUTION_REGISTRY);
        }
      } else {
        console.log(
          "[REGISTRATION DEBUG] handleIndustrySubmit: Guide registration path"
        );
        formik.values.isGuide = true;
        if (
          selectedCertificate?.voen &&
          selectedIndustryCategory?.name?.az === "Bələdçilər"
        ) {
          console.log(
            "[REGISTRATION DEBUG] handleIndustrySubmit: Guide with VOEN",
            {
              voen: selectedCertificate?.voen,
            }
          );
          let body = { voen: selectedCertificate?.voen };
          const resp = await stakeholderService.getStakeholderByIdOrVoen(body);
          console.log(
            "[REGISTRATION DEBUG] handleIndustrySubmit: Guide stakeholder fetch response",
            {
              hasData: !!resp?.data,
            }
          );

          if (resp?.data) {
            let response = await dispatch(fetchToken({ id: resp?.data?._id }));

            await dispatch(fetchNotifications(resp?.data?._id));
            if (response?.data && response?.data?.active) {
              // history.replace("/stakeholder/cabinet/home");
              window.location.href = "/stakeholder/cabinet/home";
            } else if (response?.data && !response?.data?.active) {
              history.replace("/stakeholder/new");
            } else {
              enqueueSnackbar(intl.formatMessage({ id: response.message }), {
                variant: "error",
              });
            }
          } else {
            setRegistrationStep(STEPS.STATIC_CRITERIA_QUESTIONS);
          }
        } else {
          let body = { pin: personDetails.pin };
          let resp;
          if (process.env.REACT_APP_ENV === "development") {
            resp = {
              data: {
                _id: "6718dbec3e40a1a6f44fe218",
                active: true,
              },
            };
          } else {
            resp = await stakeholderService.getStakeholderByIdOrVoen(body);
          }

          if (resp?.data) {
            let response = await dispatch(fetchToken({ id: resp?.data?._id }));

            await dispatch(fetchNotifications(resp?.data?._id));
            if (response?.data && response?.data?.active) {
              // history.replace("/stakeholder/cabinet/home");
              window.location.href = "/stakeholder/cabinet/home";
            } else if (response?.data && !response?.data?.active) {
              history.replace("/stakeholder/new");
            } else {
              enqueueSnackbar(intl.formatMessage({ id: response.message }), {
                variant: "error",
              });
            }
          } else {
            setRegistrationStep(STEPS.STATIC_CRITERIA_QUESTIONS);
          }
        }
      }
    } catch (err) {
      console.error(
        "[REGISTRATION DEBUG] handleIndustrySubmit: Error occurred",
        {
          error: err?.message,
          response: err?.response?.data,
          status: err?.response?.status,
        }
      );
      enqueueSnackbar(
        intl.formatMessage({ id: err?.response?.data.message || err.message }),
        {
          variant: "error",
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const submitGradeApplication = async (confirmed) => {
    console.log("[REGISTRATION DEBUG] submitGradeApplication: Starting...", {
      confirmed,
      isInstitution: checkIsInstitution(personDetails?.structureData?.voen),
      industryCategoryId: selectedIndustryCategory?._id,
      selectedCertificate: selectedCertificate?.certificateNumber,
    });
    try {
      let stakeholderData = null;
      if (checkIsInstitution(personDetails?.structureData?.voen)) {
        console.log(
          "[REGISTRATION DEBUG] submitGradeApplication: Preparing institution data"
        );
        stakeholderData = {
          certificateNumber: selectedCertificate?.certificateNumber,
          certificate: selectedCertificate?.certificate,
          objectRegisterationDate: `${new Date().getFullYear()}-${new Date().getMonth() +
            1}-${new Date().getDate()}`,
          personInChargePosition: {
            az: personDetails.structureData.positionName,
          },
          name: personDetails?.structureData?.structureName,
          personInChargeName: `${personDetails?.name} ${personDetails?.surname} ${personDetails?.patronymic}`,
        };
      } else {
        stakeholderData = {
          certificateNumber: selectedCertificate?.certificateNumber,
          certificate: selectedCertificate?.certificate,
          industryCategory: selectedIndustryCategory?._id,
        };
      }
      console.log(
        "[REGISTRATION DEBUG] submitGradeApplication: Preparing form data..."
      );
      const form = await prepareStaticAppForm(
        stakeholderData,
        formik.values,
        "POST",
        formik.values.isVoen,
        true
      );

      if (confirmed) {
        form.isConfirmed = true;
      }

      form.person = personDetails;
      form.pin = personDetails.pin;
      console.log(
        "[REGISTRATION DEBUG] submitGradeApplication: Form prepared",
        {
          hasForm: !!form,
          isConfirmed: form.isConfirmed,
          objectName: form.objectName,
        }
      );
      let stakeholderObj = {
        name: formik.values?.name,
        objectName: formik.values?.objectName,
        objectCode: formik.values?.objectCode,
        pin: personDetails?.pin,
        voen: personDetails?.structureData?.voen,
      };
      const tokenResponse = sessionStorage.getItem("asanLoginToken");
      const idTokenResponse = sessionStorage.getItem("asanLoginIdToken");
      console.log(
        "[REGISTRATION DEBUG] submitGradeApplication: Generating stakeholder token..."
      );
      let stakeholderToken = await loginService.generateTokenFromData(
        stakeholderObj
      );
      console.log(
        "[REGISTRATION DEBUG] submitGradeApplication: Stakeholder token generated, calling signup..."
      );
      let resp = await loginService.signup(
        form,
        stakeholderToken?.data,
        tokenResponse,
        idTokenResponse
      );
      console.log(
        "[REGISTRATION DEBUG] submitGradeApplication: Signup response",
        {
          hasData: !!resp?.data,
          message: resp?.message,
          stakeholderId: resp?.data?._id,
        }
      );
      if (resp?.data) {
        enqueueSnackbar(intl.formatMessage({ id: resp?.message }), {
          variant: "success",
        });
        await dispatch(setCurrentStakeholder(resp?.data));
        await dispatch(fetchToken({ id: resp.data?._id }));
        dispatch(fetchNotifications(resp?.data?._id));
        setTimeout(() => {
          history.replace("/stakeholder/new");
        }, 500);
      } else {
        enqueueSnackbar("Response data is not found", { variant: "error" });
      }
    } catch (err) {
      console.error(
        "[REGISTRATION DEBUG] submitGradeApplication: Error occurred",
        {
          error: err?.message,
          response: err?.response?.data,
          status: err?.response?.status,
        }
      );
      enqueueSnackbar(
        intl.formatMessage({ id: err?.response?.data.message || err?.message }),
        {
          variant: "error",
        }
      );
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Grid
      container
      justify="center"
      alignContent="center"
      className={classes.gridHV}
    >
      <Grid item md={8} sm={12}>
        <div style={{ margin: "50px 20px" }}>
          {registrationStep === STEPS.INDUSTRY_CHOICE && (
            <SelectIndustryCategory
              key={STEPS.INDUSTRY_CHOICE}
              industryCategories={industryCategories}
              person={personDetails}
              selectedIndustryCategory={selectedIndustryCategory}
              handleIndustryCategoryChange={(v) =>
                setSelectedIndustryCategory(v)
              }
              selectedObjectName={selectedObjectName}
              handleObjectNameChange={(v) => setSelectedObjectName(v)}
              selectedCertificate={selectedCertificate}
              registredStakeholders={registredStakeholders}
              handleSubmit={handleIndustrySubmit}
              handleBackButton={handleBackButton}
              voens={voens}
              registeredObjects={registeredObjects}
              newObjectName={newObjectName}
              newObjectCode={newObjectCode}
              setnewObjectName={setnewObjectName}
              setnewObjectCode={setnewObjectCode}
            />
          )}
          {registrationStep === STEPS.INSTITUTION_REGISTRY && (
            <InstitutionRegistryQuestions
              person={personDetails}
              stakeholder={selectedCertificate}
              formik={formik}
              handleSubmit={formik.handleSubmit}
            />
          )}
          {registrationStep === STEPS.STATIC_CRITERIA_QUESTIONS && (
            <StaticCriteriaQuestions
              key={STEPS.STATIC_CRITERIA_QUESTIONS}
              person={personDetails}
              stakeholder={selectedCertificate}
              selectedIndustryCategory={selectedIndustryCategory}
              selectedObjectName={selectedObjectName}
              formik={formik}
              disabled={disabled}
              setRegistrationStep={setRegistrationStep}
              handleSubmit={formik.handleSubmit}
            />
          )}
        </div>
      </Grid>

      <Modal isOpen={responsibilityModal} toggle={toggleResponsibilityModal}>
        <ModalHeader toggle={toggleResponsibilityModal}>
          {webConfig.contents.institutionRegistrationAgreement.title}
        </ModalHeader>
        <ModalBody>
          {webConfig.contents.institutionRegistrationAgreement.body}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={() => {
              toggleResponsibilityModal();
              submitGradeApplication("confirmed");
            }}
          >
            <FormattedMessage id="i_read_it" />
          </Button>{" "}
          <Button color="secondary" onClick={toggleResponsibilityModal}>
            <FormattedMessage id="cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    </Grid>
  );
};

export default Registration;

const useStyle = makeStyles({
  gridHV: {
    // height: "80vh"
  },
});
